import styled from 'styled-components';

export const Tooltip = styled.span`
  position: absolute;
  left: 50%;

  width: 120px;
  margin-left: -60px;
  padding: 5px 0;

  color: #fff;
  background-color: #555;
  border-radius: 6px;
  bottom: 150%;

  text-align: center;

  visibility: hidden;
  z-index: 10;
  opacity: 0;
  transition: opacity 0.6s;

  &::after {
    position: absolute;
    top: 100%;
    left: 50%;

    margin-left: -5px;

    border-color: #555 transparent transparent transparent;
    border-style: solid;
    border-width: 5px;

    content: '';
  }
`;
